import { preInsert, preRemove, preSave } from '@/rxdb/defaultHooks';
import defaultReplication from '@/rxdb/defaultReplication';

export const cie = {
    schema: {
        title: 'cie schema',
        version: 2,
        description: 'describes a cie',
        primaryKey: 'id',
        type: 'object',
        properties: {
            id: { type: 'string', final: true, maxLength: 40 },
            groupId: { type: ['string', 'null'], format: 'uuid' },
            projectId: { type: 'string', final: true, maxLength: 40 },
            bundleId: { type: 'string', maxLength: 40 },

            code: { type: ['string', 'null'] },
            object: { type: ['string', 'null'] },
            amountTTC: { type: ['number', 'string', 'null'] },
            emissionDate: { type: ['string', 'null'] },

            hasPaymentDelegation: { type: ['boolean', 'null'] },
            subcontractorId: { type: ['string', 'null'] },

            deletedAt: { type: ['string', 'null'] },
            createdAt: { type: ['string', 'null'] },
            createdBy: { type: ['string', 'null'] },
            updatedAt: { type: ['string', 'null'] },
            updatedBy: { type: ['string', 'null'] },

            rootVersion: { type: ['string', 'null'] },
            locationIds: {
                type: ['array', 'null'],
                items: { type: 'string', format: 'uuid' },
            },
            distribution: {
                type: ['array', 'null'],
                items: { type: 'object' },
            },
            attachments: {
                type: ['array', 'null'],
                items: { type: 'object' },
            },
            amountHT: { type: ['number', 'string', 'null'] },
            quoteStatus: { type: ['string', 'null'] },
            quoteComment: { type: ['string', 'null'] },
            quoteReference: { type: ['string', 'null'] },
            emissionDueDate: { type: ['string', 'null'], format: 'date-time' },
            deletedBy: { type: ['string', 'null'], format: 'uuid' },
        },
    },
    options: {
        onCollectionCreated(projectId, rxCollection) {
            rxCollection.replicationState = defaultReplication(rxCollection, projectId);
            rxCollection.preRemove(preRemove, false);
            rxCollection.preInsert(preInsert, false);
            rxCollection.preSave(preSave, false);
        },
    },
    migrationStrategies: {
        1: (doc) => doc,
        2: (doc) => ({ ...doc, hasPaymentDelegation: false, subcontractorId: null }),
    },
};
